import './App.css';
import { useState } from 'react';
import SalaryCalculator from './salary-calculator';

/**
 * Modal component for displaying content in a pop-up window.
 * 
 * @param {Object} props - The properties passed to the Modal component.
 * @param {string} props.label - The text to display on the button that opens the modal.
 * @param {string} props.title - The title to display at the top of the modal.
 * @param {Array} props.currentQuestion - An array of content objects to be rendered in the modal.
 * @param {function} props.setIsActive - A function to set the active state of the parent component.
 * @param {string} props.stepCode - The step code to display in the pay code stub.
 * @param {string} props.differential - The differential to display in the pay code stub.
 * @returns {JSX.Element} A button that opens the modal and the modal content when opened.
 */
function Modal(props) {
  let [showModal, setShowModal] = useState(false),
      listContent,
      listAlert;

  // Function to handle modal toggle
  function handleModal(event){
    // Reference to the main wrapper element for scrolling
    const scrollToTop = document.querySelector('.main');

    setShowModal(!showModal);
    props.setIsActive(!props.isActive);

    setTimeout(() => {
        scrollToTop.scrollIntoView({
            behavior: 'smooth'
        }, 500)
    }, 60);
  }

  // Render content based on the current question
  const contents = props.currentQuestion;
  if(contents && Array.isArray(contents)){
    listContent = contents.map((content, index) =>
      <>
        {content.type == "Content Box" && 
        <div className='content-box flex flex-row' style={{justifyContent: content.textAlign}}>
          {content.icon && <div className='icon' id={content.icon}><span className='sr-only'>{content.icon} icon</span></div>}
          <div>
            {content.title && <h3 key={`title-${index}`} className="title" style={{textAlign: content.textAlign}}>{content.title}</h3>}
            <p key={`content-${index}`} className={`content ${content.textSize}`} style={{textAlign: content.textAlign}} dangerouslySetInnerHTML={{__html: content.content}}></p>
            {content.listItems &&
              <ul>
                {content.listItems &&
                  content.listItems.map((item) => {
                    return (
                      <li>{item}</li>
                    );
                  })
                }
              </ul>
            }
          </div>
        </div>}
        {content.type != "Content Box" && 
        <>
        {content.subTitle && <h3 key={`subTitle-${index}`} className="sub-title" style={{textAlign: content.textAlign}} dangerouslySetInnerHTML={{__html: content.subTitle}}></h3>}
        <p key={`content-${index}`} className={`content ${content.textSize}`} style={{textAlign: content.textAlign}} dangerouslySetInnerHTML={{__html: content.content}}></p>
        </>
        }
        {(content.listItems && content.type != "Content Box") &&
          <ul>
            {content.listItems &&
              content.listItems.map((item) => {
                return (
                  <li>{item}</li>
                );
              })
            }
          </ul>
        }
        {content.image &&
          <img key={`image-${index}`} width={content.width} className="image" src={content.image} alt={content.alt} />
        }
        {(content.type == "Pay Code") &&
          <div className="pay-code-stub">
            {props.jobTitle != "paraprofessionals" ? <p className='pay-code'>{props.stepCode && (content.codeType == "differential") ? <p>{props.calculatedPayCode}{props.hoursPerWeek}</p> : <p>{props.stepCode}</p>}</p> : <p className='pay-code'>{props.differential}</p>}
          </div>
        }
        {(content.type == "External Link") &&
          <a href={content.link} target="_blank" rel="noopener noreferrer" className={content.isButtonStyle ? "default-button next-button" : "text-link"}>{content.label}</a>
        }
        {(content.type == "Salary Calculator") &&
          <SalaryCalculator row={props.row} column={props.column}/>
        }
      </>
    )
  }

  // Render out alert ABOVE title
  if(contents && Array.isArray(contents)){
    listAlert = contents.map((alert, index) =>
      (alert.type == "Alert") &&
      <div className='alert-wrapper'>
          <div className={`alert ${alert.level}`}>
              <p className='content no-margin'>{alert.alert}</p>
          </div>
      </div>
    )
  }

  return (
    <>
      <button className="text-link" onClick={handleModal}>{props.label}</button>
      {showModal && 
        <div className="modal">
          <div className="modal-inner">
            <div className="content-wrapper">
              <button className="close-button" onClick={handleModal}><span className="sr-only">Close</span></button>
              {listAlert}
              <h2 className='title'>{props.title}</h2>
              {listContent}
              <button className="default-button" onClick={handleModal}>Close</button>
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default Modal;